import { render, staticRenderFns } from "./EventCompactCard.vue?vue&type=template&id=8dc3b434&scoped=true"
var script = {}
import style0 from "./EventCompactCard.vue?vue&type=style&index=0&id=8dc3b434&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8dc3b434",
  null
  
)

export default component.exports